export default {
    insertInvite: "/gateway/huilianOperation/invitecs/insertInvite", //拉新邀请
};



// WEBPACK FOOTER //
// ./src/invitation/invitationOpen/api.js